import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import invoiceLogo from "../../../../assets/images/invoicing-icon.svg";
import CommercialAirlineNavigationBar from "../../../../components/element/CommercialAirlineNavigationBar";
import ROUTE_PATHS from "../../../../utils/routePaths";
import ViewIATAInvoicingTable from "./Tables/ViewIATAInvoicingTable";
import useAirlineAdminApi from "../../../../services/api/useAirlineAdminApi";
import { useQuery } from "@tanstack/react-query";
import { formatToTwoDecimal } from "../../../../utils/utils";

function ViewIATAInvoicing() {
  const navigate = useNavigate();
  const { fetchIATAInvoicesBillingBreakdown } = useAirlineAdminApi();
  const [selectedIATAInvoicing, setSelectedIATAInvoicing] = useState([]);
  const [iataInvoicingData, setIATAInvoicingData] = useState(null);
  const [grandTotal, setGrandTotal] = useState(0);

  const {
    data: iataInvoicesbillingBreakdown,
    isLoading,
    error,
  } = useQuery({
    queryKey: [
      "get-iata-invoices-billing-breakdown",
      iataInvoicingData?.billingDocument,
    ],
    queryFn: () =>
      fetchIATAInvoicesBillingBreakdown(iataInvoicingData?.billingDocument),
    enabled: !!iataInvoicingData,
  });

  useEffect(() => {
    const storedData = localStorage.getItem("iataInvoicingData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setIATAInvoicingData(parsedData);
    }
    setGrandTotal(calculateGrandTotal());
  }, [selectedIATAInvoicing]);

  const calculateGrandTotal = () => {
    return selectedIATAInvoicing.reduce((accumulator, item) => {
      return accumulator + (item?.billingAmountAfterTaxLoan || 0);
    }, 0);
  };

  const handleViewInvoiceClick = () => {
    navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICING_IATA_VIEW_FLIGHT_DETAILS);
  };

  return (
    <div>
      <div className="invoicing-IATA-container">
        <CommercialAirlineNavigationBar
          title={"IATA Billing Breakdown"}
          navigationLogo={invoiceLogo}
          backContent={
            <div className="navigation-header">
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                className="navigation-header-link"
              >
                Home/
              </Link>
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICING_IATA}
                className="navigation-header-link"
              >
                IATA Invoices/
              </Link>
              View
            </div>
          }
        />
        <div className="invoicing-IATA-grand-total-container">
          {`Grand Total: USD ${formatToTwoDecimal(grandTotal)}`}
        </div>
        <ViewIATAInvoicingTable
          invoicingData={iataInvoicesbillingBreakdown?.data}
          isLoading={isLoading}
          error={error}
          selectedIATAInvoicing={selectedIATAInvoicing}
          setSelectedIATAInvoicing={setSelectedIATAInvoicing}
          onClickView={handleViewInvoiceClick}
        />
      </div>
    </div>
  );
}

export default ViewIATAInvoicing;
